import React from 'react'

const Duppata = () => {
  return (
    <div>Duppata</div>
  )
}

export default Duppata